import { BaseOption } from "entities/common";

export const FORMAT_OPTIONS: BaseOption[] = [
  { value: "", label: "All formats" },
  { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel" },
  { value: "csv", label: "CSV" },
];
